import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LangSwitcherComponent } from '@shared/components/lang-switcher/lang-switcher.component';

@Component({
	selector: 'app-public-layout',
	imports: [RouterOutlet, LangSwitcherComponent],
	templateUrl: './public-layout.component.html',
	styleUrl: './public-layout.component.scss',
})
export class PublicLayoutComponent {}
